import Vue from "vue";
import { Document } from "@/tools/msa/models";
import { computed, Ref } from "@vue/composition-api";
import { sanitize } from "@/tools/msa/utils/sanitization";
import { useTextSelection } from "@/tools/msa/utils/selection/text";
import { useTokensSelection } from "@/tools/msa/utils/selection/tokens";

export const useSelection = (
  props: { document: Document },
  container: Ref<Vue | HTMLElement | null>
) => {
  const tokens = useTokensSelection(props);
  const text = useTextSelection(container);

  const selection = computed<string>(() =>
    tokens.selected.value.length > 0
      ? sanitize(
          tokens.selected.value
            .map(token => `${token.text}${token.delimiter}`)
            .join("")
            .trim()
            .replace(/\t/g, " "),
          text.selected.value
        )
      : text.selected.value
  );

  const range = computed<Range | null>(() => text.range.value);

  const reset = () => {
    text.reset();
    tokens.reset();
  };

  return { selection, range, reset };
};
